// extracted by mini-css-extract-plugin
export default {"container":"Presentation_container__luiXc","text":"Presentation_text__POACf"};